export enum SortDirection {
    Ascending = 'ASC',
    Descending = 'DESC',
}

export type SortSetting = {
    direction: SortDirection
    field: string
}
